import React from 'react';
import { useLocation } from '@reach/router';
import './MiscellaneousTutorialsBoxs.scss';

interface MiscellaneousTutorialsBoxsProps {
  contributeBoxUrl: string;
}

export default function MiscellaneousTutorialsBoxs({ contributeBoxUrl }: MiscellaneousTutorialsBoxsProps): React.ReactElement {
  const location = useLocation();
  const parts = location.pathname.split('/');

  return (
    <div className="boxs">
      <div className="boxs__changes">
        <h4>Suggest changes</h4>
        <p>
          The content on <a href={process.env.GATSBY_DOCS_URL}>docs.arduino.cc</a> is facilitated through a public{' '}
          <a
            href={
              parts.includes('en') || parts.includes('de') || parts.includes('es')
                ? 'https://github.com/arduino/docs-content-reference'
                : 'https://github.com/arduino/docs-content'
            }
          >
            GitHub repository
          </a>
          . If you see anything wrong, you can edit this page{' '}
          <a href={`https://github.com/arduino/docs-content/edit/main/content/${contributeBoxUrl}`}>here</a>.
        </p>
      </div>
      <div className="boxs__support">
        <h4>Need support?</h4>
        <a href="https://support.arduino.cc/">Help Center</a>
        <a href="https://forum.arduino.cc/">Ask the Arduino Forum</a>
        <a href="https://discord.gg/jQJFwW7">Discover Arduino Discord</a>
      </div>
      <div className="boxs__license">
        <h4>License</h4>
        <p>
          The Arduino documentation is licensed under the{' '}
          <a href="https://creativecommons.org/licenses/by-sa/4.0/">Creative Commons Attribution-Share Alike 4.0</a> license.
        </p>
      </div>
    </div>
  );
}
